import React from "react";
import { Link } from "react-router-dom";
import "./menuLeftProvLealtad.css";
//
import logoAmebo from "../../../Lealtad/assets/logo/logo2.png";
//
import { MdOutlineAttachMoney } from "react-icons/md";
import {
  FaFileSignature,
  FaClipboardList,
  FaUserAlt,
  FaHandsHelping,
} from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import { GoFileSubmodule } from "react-icons/go";
import { RiLockPasswordFill } from "react-icons/ri";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuProvComercializadorLealtad = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="allmenuleftlealtad">
      <div className="boxlogoprovlealtad">
        <img className="logomenuleftprovlealtad" src={logoAmebo} alt="logo" />
      </div>
      <div className="boxallbuttonprovlealtad">
        <Link to="/portal-comercializadores-lealtad/mis-ventas">
          <div className="boxbuttonprovlealtad">
            <p className="letterbuttonprovlealtad">
              <MdOutlineAttachMoney className="iconprovlealtad" />
              Mis ventas
            </p>
          </div>
        </Link>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "Perfil")}
        >
          <p className="letterbuttonprovlealtad">
            <FaUserAlt className="iconprovlealtad" />
            Perfil
          </p>
        </div>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "Convenio")}
        >
          <p className="letterbuttonprovlealtad">
            <FaFileSignature className="iconprovlealtad" />
            Convenio con entidad
          </p>
        </div>
        <Link to="/portal-comercializadores-lealtad/mis-facturas">
          <div className="boxbuttonprovlealtad">
            <p className="letterbuttonprovlealtad">
              <FaClipboardList className="iconprovlealtad" />
              Mis facturas
            </p>
          </div>
        </Link>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "Factura")}
        >
          <p className="letterbuttonprovlealtad">
            <FaHandsHelping className="iconprovlealtad" />
            Subir factura
          </p>
        </div>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "Documentacion")}
        >
          <p className="letterbuttonprovlealtad">
            <GoFileSubmodule className="iconprovlealtad" />
            Mi documentacion
          </p>
        </div>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "Contraseña")}
        >
          <p className="letterbuttonprovlealtad">
            <RiLockPasswordFill className="iconprovlealtad" />
            Cambiar contraseña
          </p>
        </div>
        <div className="boxbuttonprovlealtad" onClick={handleLogout}>
          <p className="letterbuttonprovlealtad">
            <FaDeleteLeft className="iconprovlealtad" />
            Salir
          </p>
        </div>
      </div>
    </div>
  );
};

export default MenuProvComercializadorLealtad;
